const config = {
  api: 'wss://hackathon-agm-api.boardpro.dev',
  // api: 'ws://localhost:8080',
}

export default config
